export const QUERY_CONFIG = {
   staleTime: 5 * 60 * 1000, // 5 minutes
   cacheTime: 30 * 60 * 1000, // 30 minutes
} as const;
